import React, { useState, useContext, useMemo } from 'react';
import { ReactChildrenPropType } from '../../lib/commonPropTypes';

const NavigationContext = React.createContext();

export function NavigationProvider(props) {
  const { children } = props;
  const [contextValues, setContextValues] = useState({
    tertiaryNavigationActionables: null,
    breadcrumbVariables: {}
  });

  const updateStore = (params) => {
    setContextValues((prevState) => ({ ...prevState, ...params }));
  };

  // Memoize the context values to prevent unnecessary re-renders
  const memoizedContextValue = useMemo(() => ({ ...contextValues, updateStore }), [contextValues]);

  return <NavigationContext.Provider value={memoizedContextValue}>{children}</NavigationContext.Provider>;
}

NavigationProvider.propTypes = {
  children: ReactChildrenPropType.isRequired
};

export const useNavigation = () => {
  const contextValue = useContext(NavigationContext);
  if (contextValue === undefined) {
    throw new Error('useNavigation must be used within a NavigationProvider');
  }
  return contextValue;
};
